<template>
  <div>
    <!-- {{id}} -->
    <!-- {{ model }} -->
    <!-- <div>StageId {{stageId}}</div> -->
    <!-- {{ canChangeTower }} -->
    <!-- <div>Latitude: {{model.lastStatusLatitude}} / Longitude: {{model.lastStatusLongitude}}</div> -->
    <div>
      <a
        v-if="canViewMap"
        title="Localização"
        class="card-buttons"
        @click="openMap()"
        v-b-tooltip.hover
      >
        <b-button size="sm" class="ml-2 mb-0 mt-0 pb-2">
          <i class="tim-icons icon-square-pin"></i>
        </b-button>
      </a>
      <a
        v-if="canEditFilled"
        title="Editar"
        class="card-buttons"
        v-b-tooltip.hover
        @click="openModalEdit()"
      >
        <b-button size="sm" class="ml-2 mb-0 mt-0 pb-2">
          <i class="tim-icons icon-pencil"></i>
        </b-button>
      </a>
      <a
        v-if="canChangeTower"
        title="Próxima etapa"
        class="card-buttons"
        v-b-tooltip.hover
        @click="openModalNextStage()"
      >
        <b-button size="sm" class="ml-2 mb-0 mt-0 pb-2">
          <i class="tim-icons icon-double-right"></i>
        </b-button>
      </a>
      <a
        title="Comentário"
        class="card-buttons"
        v-b-tooltip.hover
        @click="openComment()"
      >
        <b-button size="sm" class="ml-2 mb-0 mt-0 pb-2">
          <i class="tim-icons icon-notes"></i>
        </b-button>
      </a>
    </div>

    <stage-modal-next ref="stageModalNext" :id="id" @refreshData="refreshData">
    </stage-modal-next>

    <process-filled-modal
      ref="processFilledModal"
      :filledId="id"
      @refreshData="refreshData"
    >
    </process-filled-modal>

    <workflow-map-modal
      ref="workflowMap"
      :latitude="model.lastStatusLatitude"
      :longitude="model.lastStatusLongitude"
    >
    </workflow-map-modal>

    <stage-comment-modal
      ref="stageCommentModal"
      :filledId="id"
      :stageId="stageId"
      :canComment="canComment"
    >
    </stage-comment-modal>
    <!-- {{ model }} -->
  </div>
</template>
  <script>
export default {
  name: "WorkflowFilledActions",
  props: {
    id: Number,
    stageId: String,
    model: Object,
    tower: Object,
    permission: Object,
  },
  components: {
    'workflow-map-modal': () => import("@/components_rms/workflow/WorkflowMapModal.vue"),
    StageModalNext: () =>
      import("@/components_rms/workflow/Stage/StageModalNext.vue"),
    ProcessFilledModal: () =>
      import("@/components_rms/workflow/Process/ProcessFilledModal.vue"),
    StageCommentModal: () =>
      import("@/components_rms/workflow/Stage/StageCommentModal.vue"),
  },
  computed: {
    canEditFilled() {
      if (this.permission.advancedOperate) return true;
      if (this.permission.administrador) return true;
      if (this.permission.gestor) return true;
      return false;
    },
    canViewMap() {
      if (this.permission.advancedOperate) return true;
      if (this.permission.administrador) return true;
      if (this.permission.gestor) return true;
      return false;
    },
    canChangeTower() {
      if (this.permission.simpleOperate) return true;
      if (this.permission.advancedOperate) return true;
      if (this.permission.administrador) return true;
      if (this.permission.gestor) return true;
      return false;
    },
    canComment() {
      if (this.model.CanComment == "True") return true;
      else return false;
    },
  },
  methods: {
    openModal() {
      this.$refs.openModal.show();
    },
    openMap() {
      this.$refs.workflowMap.openModal();
    },
    openModalEdit() {
      this.$refs.processFilledModal.show();
    },
    openModalNextStage() {
      this.$refs.stageModalNext.show();
    },
    openComment() {
      this.$refs.stageCommentModal.show();
    },
    refreshData() {
      // console.log('StageSettings -> refreshData()');
      this.$emit("refreshData");
    },
  },
};
</script>
  